import React from "react";
import styles from "./homePage.module.css";
import Header from "../../components/header/header";
import SlideShow from "../../components/slideshow/slideshow";
import sliderData from "../../components/slideshow/sliderData.js";

const HomePage = () => {
  return (
    <div className={styles.container}>
      <Header homePage={true} />
      <SlideShow slides={sliderData} />
    </div>
  );
};

export default HomePage;
